<template>
    <div class="main-container">
        <div class="w">
            <div class="CourseDetails_box">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item :to="{ path: '/pcViews/learn/train' }"
                        >教育培训</el-breadcrumb-item
                    >
                    <el-breadcrumb-item
                        class="item_now"
                        >公告详情</el-breadcrumb-item
                    >
                </el-breadcrumb>
            </div>
            <div class="details_box bgWhite"   v-if="hasNews">
                <div class="details_title">
                    {{ details.title }}
                </div>
                <div class="details_news">
                    <div class="details_news_left">
                        <p>日期：{{ details.createDate }}</p>
                    </div>
                </div>
                <div
                    class="details_content"
                    v-html="noticeUnescapeHtml(details.content)"
                ></div>
            </div>
        </div>
    </div>
</template>
<script>
import { PcCookie, Key } from "@/utils/cookie";
import { unescapeHTML } from "utils/validate";
import { getCategoryNotifyDetail } from "api/train";
export default {
    computed: {
        //文章转义字符
        noticeUnescapeHtml() {
            return function (content) {
                return unescapeHTML(content);
            };
        },
    },
    data() {
        return {
            size: 16,
            details: {},
            preArticle: {},
            nextArticle: {},
            noticeId: "",
            beginFontSize: null,
            attachment: [],
            hasNews:false
        };
    },
    created() {
        this.noticeId = this.$route.query.noticeId;
        this.fetchData(this.noticeId);
    },
    methods: {
        fetchData(id) {
            const sessionId = PcCookie.get(Key.jsessIdKey);
            getCategoryNotifyDetail(sessionId,id).then((res) => {
                let { success, errorCode, body, msg } = res;
                if (success && errorCode == "2000") {
                    this.details = body.data;
                    this.hasNews = true;
                } else {
                    this.$message({
                        type: "danger",
                        message: msg,
                    });
                }
            });
        },
    },
};
</script>
<style>
.details_content img {
    max-width: 100%;
}
.details_content.small p {
    font-size: 14px 18px !important;
    line-height: 32px !important;
}
.details_content.big p {
    font-size: 20px !important;
}
.details_content p {
    color: #3b3b3b;
}
</style>
<style scoped lang="less">
.fujian {
    margin-top: 20px;
    font-size: 16px;
    color: #8f8f8f;
    display: flex;
    flex-direction: row;
    p {
        width: 60px;
    }
    div {
        line-height: 24px;
        em {
            margin-left: 20px;
            font-style: normal;
            color: #6073ce;
            cursor: pointer;
        }
    }
}
.page_news p {
    line-height: 26px;
    cursor: pointer;
}
.page_news {
    margin: 26px 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 62px;
    font-size: 16px;
    color: #3b3b3b;
}
.details_content {
    padding: 26px 0;
    border-bottom: dashed 1px #3b3b3b;
}
.details_news_right span {
    cursor: pointer;
    margin: 0 8px;
}
.details_news_right p {
    margin-right: 40px;
}
.details_news_right {
    display: flex;
}
.details_news_left p {
    margin-right: 40px;
}
.details_news_left {
    display: flex;
}
.details_news {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    height: 82px;
    font-size: 14px;
    color: #3b3b3b;
    border-bottom: solid 5px #8f8f8f;
}
.details_title {
    line-height: 42px;
    font-size: 30px;
    font-weight: bold;
    color: #000;
    text-align: center;
}
.details_box {
    margin: 20px 0;
    padding: 14px 20px;
}
</style>

